import moment from "moment-jalaali";

function dateTimeToJalali(date) {
  const momentDate = moment(date);
  return {
    iso: momentDate.format("jYYYY_jMM_jDDTHH_mm_ss"),
    date: momentDate.format("jYYYY/jMM/jDD"),
    time: momentDate.format("HH:mm:ss"),
    shortTime: momentDate.format("HH:mm"),
    full: momentDate.format("jYYYY/jMM/jDD HH:mm:ss"),
  };
}

export default dateTimeToJalali;
